const c = {
  width: 450,
  height: 750
};
function r() {
  return {
    theme: "light",
    tokens: {},
    partOverrides: [],
    rawCss: ""
  };
}
function a() {
  return {
    modality: "floating"
  };
}
function i() {
  return {
    customerLogoUrl: ""
  };
}
function d() {
  return {
    design: r(),
    shell: a(),
    branding: i()
  };
}
const g = {
  // Drives `PypeConfig.theme` as well, so the host element's `data-theme`
  // reflects the saved theme on first paint rather than after STYLES_UPDATE.
  "design.theme": {
    hostKey: "theme",
    strategy: "blob-wins-if-set",
    live: !0
  },
  "design.tokens": { hostKey: null, strategy: "blob-only", live: !0 },
  "design.partOverrides": { hostKey: null, strategy: "blob-only", live: !0 },
  "design.rawCss": { hostKey: null, strategy: "blob-only", live: !0 },
  // The one field a host may override per-embed: the same bot floats on one page
  // and fills `/support` on another, so the blob is a default, not a decision.
  "shell.modality": { hostKey: "modality", strategy: "host-wins", live: !1 },
  // Designer-owned and boot-immutable: there is no host attribute, and the
  // floating panel falls back to `DEFAULT_SHELL_SIZE` when it resolves to
  // `undefined`. Applies to the anchored floating panel only.
  "shell.size": { hostKey: "size", strategy: "blob-only", live: !1 },
  "branding.displayName": { hostKey: null, strategy: "blob-only", live: !0 },
  "branding.customerLogoUrl": {
    hostKey: "customerLogoUrl",
    strategy: "blob-wins-if-set",
    live: !0
  },
  "branding.brandMomentUrl": {
    hostKey: null,
    strategy: "blob-only",
    live: !0
  },
  "branding.launcherName": {
    hostKey: "launcherButtonText",
    strategy: "blob-wins-if-set",
    live: !0
  },
  // `language` describes the page the embed sits on, so an explicit host value
  // outranks the saved design.
  "branding.language": {
    hostKey: "language",
    strategy: "host-wins",
    live: !0
  },
  // Rendered only inside the connecting window, so a live push would visibly do
  // nothing — the same reason `shell.showInlineLoader` is not live.
  "branding.welcome": {
    hostKey: "initialMessages",
    strategy: "blob-wins-if-present",
    live: !1
  },
  // The presentation leaves below are all `live: false` TODAY, and that is a
  // statement about the widget, not a preference: nothing re-applies them after
  // boot, and `<ps-pype>`'s `set config` is deliberately inert. Making any of
  // them live needs the sanctioned route — an `@internal` method plus a machine
  // event — per the contract on `attributeChangedCallback`.
  // Rendered only inside the connecting window, so a live push would visibly do
  // nothing — a remount is not a shortcut here, it is the only way to observe a
  // change at all.
  "shell.showInlineLoader": {
    hostKey: "showInlineLoader",
    strategy: "blob-wins-if-present",
    live: !1
  },
  // `host-wins`, NOT `blob-wins-if-present`, and for the same reason as
  // `shell.modality`: ONE saved design serves many embeds, and these can differ
  // between them — the same channel may be floated on a marketing page and
  // mounted headless behind a host's own button in an app. The design states the
  // default; the embed overrides it for its own page.
  //
  // It is also a correctness requirement, not a preference. The Loader forces
  // `launcher: 'none'` for `target: 'window'` (`loader.ts` `_widgetConfig`) —
  // a popup has no host page to anchor a FAB to. Under `blob-wins-if-present` a
  // saved design carrying `'default'` overwrote that force and the popup got a
  // launcher plus a corner-anchored panel instead of filling the window.
  //
  // This only works because BOTH host paths now leave these `undefined` when
  // unset (`getConfigFromHost`, and `normalizeAppConfig` in the Loader). A host
  // default here would make the blob unreachable — the same trap `language` hit.
  "shell.useIframe": {
    hostKey: "useIframe",
    strategy: "host-wins",
    live: !1
  },
  "shell.launcher": {
    hostKey: "launcher",
    strategy: "host-wins",
    live: !1
  },
  // Read from context by the shells, but ALSO from a boot-captured config by
  // `floating-modality` for the panel spring — so live would require both an
  // event and re-pointing those two reads.
  "shell.disableSlideAnimation": {
    hostKey: "disableSlideAnimation",
    strategy: "blob-wins-if-present",
    live: !1
  }
}, y = {
  appId: "host-only",
  language: "merged",
  theme: "designer-only",
  customerLogoUrl: "designer-only",
  launcherButtonText: "merged",
  modality: "merged",
  size: "designer-only",
  useIframe: "merged",
  launcher: "merged",
  anchorTo: "internal",
  target: "capability",
  window: "capability",
  user: "host-only",
  passthrough: "host-only",
  initialMessages: "merged",
  showInlineLoader: "merged",
  disableSlideAnimation: "merged",
  debug: "internal",
  preview: "internal",
  skipDesignFetch: "internal",
  engagementApiUrl: "internal"
}, o = {
  floating: {},
  fullpage: {
    useIframe: { reason: "owns-the-page", coerceTo: !1 },
    launcher: { reason: "no-launcher", coerceTo: "none" },
    size: { reason: "fills-container" },
    launcherButtonText: { reason: "no-launcher" }
  }
};
function b(e, t) {
  return !(t in o[e]);
}
function f(e, t) {
  return o[e][t]?.reason ?? null;
}
const u = Object.keys(g);
function h(e) {
  const t = e.indexOf(".");
  return [e.slice(0, t), e.slice(t + 1)];
}
function m(e) {
  const t = {};
  for (const n of u) {
    const [s, l] = h(n);
    (t[s] ??= {})[l] = e[s][l];
  }
  return t;
}
export {
  u as B,
  c as D,
  y as H,
  o as M,
  g as P,
  r as a,
  a as b,
  i as c,
  d,
  f as i,
  b as m,
  m as p,
  h as s
};
//# sourceMappingURL=field-ownership-BAZx24fO.js.map
